<template>
  <div class="cons-liquidations">
    <b-form>
      <b-overlay :show="loading" rounded="sm" @shown="onShown" @hidden="onHidden">
        <input id="contrato-id" type="hidden" v-model="contrato.id" />
        <h2>
          Utilize este formulário para inserir um lote de liquidações do BB
        </h2>
        <div id="actions" class="validacao-barra mb-3 mt-2">
          <div class="validacao-botoes">
            <b-button variant="primary" :disabled="!contrato.lines || loading" @click="save()">Salvar</b-button>
            <b-button variant="warning" @click="getValidation()" :disabled="loading">Ver Validação</b-button>
            <b-button variant="success" @click="setNewValidation()" :disabled="loading">Nova Validação</b-button>
          </div>
          <b-form-group class="campo-exercicio mb-0" label="Exercício" label-for="contrato-exercicio">
            <b-form-select id="contrato-exercicio" :options="optionExercicios" v-model="contrato.exercicio"
              :disabled="loading" />
          </b-form-group>
          <b-form-group class="campo-versao mb-0" label="Versão" label-for="contrato-versao">
            <b-form-input type="number" id="contrato-versao" title="Versão" v-b-tooltip.hover
              v-model="contrato.versao" ref="versao" />
          </b-form-group>
        </div>
        <div v-if="!informarLinhas">
          <b-form-group label="PDF do Banco do Brasil" label-for="contrato-pdf">
            <p class="mb-2">Informe o exercício e a versão. O PDF só é lido depois disso, e o lote entra nesse exercício.</p>
            <div class="pdf-drop" :class="{ 'pdf-drop-active': pdfDragover, 'pdf-drop-off': !camposOperacao }" @dragover.prevent="pdfDragover = camposOperacao"
              @dragleave.prevent="pdfDragover = false" @drop.prevent="onPdfDrop" @click.stop="escolherPdf">
              <input ref="pdfInput" id="contrato-pdf" type="file" accept="application/pdf,.pdf" class="d-none"
                @change="onPdfPick" />
              <span v-if="pdfFile">{{ pdfFile.name }}</span>
              <span v-else-if="!camposOperacao">Escolha o exercício e a versão para enviar o PDF</span>
              <span v-else>Arraste o PDF aqui ou clique para escolher</span>
            </div>
            <div class="mt-2">
              <b-button class="mr-2" variant="info" :disabled="!podeImportarPdf" @click="importarPdf">Importar PDF e
                baixar planilhas</b-button>
              <b-button variant="outline-secondary" :disabled="loading" @click="informarLinhas = true">Informar linhas</b-button>
            </div>
          </b-form-group>
        </div>
        <div v-else>
          <b-row v-if="!validationResult">
            <b-col>
              <b-form-group label="Lote de liquidações de convenentes" label-for="contrato-lines">
                <h5 class="bold">
                  !!! Importante: Não informar cabeçalhos de colunas
                </h5>
                <h6>
                  Nome;Matrícula;Nr.operação;Seq.oper.;CPF;Valor parcela;Valor consignado
                </h6>
                <b-form-textarea id="contrato-lines" v-model="contrato.lines"
                  placeholder="Cole aqui as linhas contendo os dados conforme o leiaute acima e as colunas separadas por ';'(ponto e vírgula)."
                  rows="10"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <b-button class="mb-3" variant="info" :disabled="loading" @click="informarLinhas = false">Importar PDF e baixar planilhas</b-button>
        </div>
        <div v-if="validationResult">
          <span style="font-size: 1.25rem;">Resultado das validações</span><br><span style="color: red;">Após corrigir
            tudo, se necessário importe novos dados</span>
          <b-row>
            <b-col md="4" v-for="item in validationResult" :key="item">
              <span v-html="item" />
            </b-col>
          </b-row>
        </div>
        <template #overlay>
          <div class="text-center">
            <Loading />
            <p id="cancel-label">
              Você pode continuar esperando ou pode clicar abaixo e até sair da
              página. Só não pode fechar o navegador. Ok? &#128521;
            </p>
            <p id="cancel-label">
              A importação ocorrerá mesmo que esta aba seja fechada
            </p>
            <h3>Por favor aguarde. Isso pode levar vários minutos...</h3>
            <b-button ref="cancel" variant="outline-danger" size="sm" aria-describedby="cancel-label"
              @click="loading = false">
              Não quero esperar
            </b-button>
          </div>
        </template>
      </b-overlay>
    </b-form>
    <p v-if="userParams.admin">contrato: {{ contrato }}</p>
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";
import { showError } from "@/global";
import { baseApiUrl } from "@/env";
import { capitalizeFirst } from "@/config/globalFacilities";
import Loading from "@/components/template/Loading";

export default {
  name: "ContrValidations",
  components: { Loading },
  data: function () {
    return {
      userParams: {},
      validationResult: undefined,
      itemModal: {
        id: "item-modal",
        title: "",
        content: "",
      },
      loading: false,
      contrato: {
        versao: 1,
        exercicio: "",
        id_consignatario: 1,
      },
      optionExercicios: [],
      consignatario: {},
      pdfFile: null,
      pdfDragover: false,
      informarLinhas: false,
    };
  },
  methods: {
    setExercicios() {
      const optionExercicios = [];
      const startDate = new Date(2024, 6); // Julho de 2024 (mês é 0-indexado)
      const endDate = new Date(); // Mês atual

      let currentDate = startDate;

      while (currentDate <= endDate) {
        const year = currentDate.getFullYear();
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Adiciona zero à esquerda se necessário

        const value = `${year}${month}`;
        const text = `${month}/${year}`;

        optionExercicios.push({ value, text });

        // Incrementa para o próximo mês
        currentDate.setMonth(currentDate.getMonth() + 1);
      }

      this.optionExercicios = optionExercicios;
    },
    async getConsignees() {
      this.contrato.id_consignatario = 1;
      const url = `${baseApiUrl}/consignatarios/f/gcgn`;
      await axios.get(url).then((res) => {
        const bancoBrasil = (res.data.data || []).find((data) => String(data.id_consignatario) === '1');
        this.consignatario = { value: 1, unConv: bancoBrasil ? bancoBrasil.unico_municipio : 0 };
        this.contrato.id_consignatario = 1;
      });
    },
    setNewValidation() {
      this.contrato.versao = 1;
      this.loading = false;
      this.validationResult = undefined;
      this.pdfFile = null;
    },
    setPdf(file) {
      this.pdfDragover = false;
      if (!file) return;
      const nome = (file.name || '').toLowerCase();
      if (file.type && file.type !== 'application/pdf' && !nome.endsWith('.pdf')) {
        this.$toasted.global.defaultError({ msg: 'Envie um arquivo PDF' });
        return;
      }
      this.pdfFile = file;
    },
    onPdfDrop(event) {
      if (!this.camposOperacao) {
        this.pdfDragover = false;
        this.$toasted.global.defaultError({ msg: 'Informe o exercício e a versão antes de importar o PDF' });
        return;
      }
      const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
      this.setPdf(file);
    },
    escolherPdf() {
      if (!this.camposOperacao) {
        this.$toasted.global.defaultError({ msg: 'Informe o exercício e a versão antes de importar o PDF' });
        return;
      }
      this.$refs.pdfInput.click();
    },
    onPdfPick(event) {
      const file = event.target.files && event.target.files[0];
      this.setPdf(file);
      event.target.value = '';
    },
    baixarBase64(nome, conteudo, mime) {
      const binary = atob(conteudo);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
      const url = URL.createObjectURL(new Blob([bytes], { type: mime }));
      const element = document.createElement('a');
      element.href = url;
      element.download = nome;
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
      URL.revokeObjectURL(url);
    },
    importarPdf() {
      if (!this.camposOperacao) {
        this.$toasted.global.defaultError({ msg: 'Informe o exercício e a versão antes de importar o PDF' });
        return;
      }
      const unConv = this.consignatario && Number(this.consignatario.unConv) === 1;
      const url = `${baseApiUrl}/con-validacoes${unConv ? '-un-conv' : ''}/pdf`;
      const form = new FormData();
      form.append('pdf', this.pdfFile);
      form.append('exercicio', this.contrato.exercicio || '');
      form.append('versao', this.contrato.versao || '');
      form.append('id_consignatario', 1);
      this.loading = true;
      axios.post(url, form)
        .then((res) => {
          const arquivos = res.data.arquivos || {};
          if (arquivos.csv) this.baixarBase64(arquivos.csv.nome, arquivos.csv.conteudo, 'text/csv');
          if (arquivos.xlsx) this.baixarBase64(arquivos.xlsx.nome, arquivos.xlsx.conteudo, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
          if (res.data.gravacaoOk) {
            this.$toasted.global.defaultSuccess({ msg: 'Lote importado. CSV e Excel baixados.' });
            this.exibirValidacao(res.data.inconsistencias);
          } else {
            this.$toasted.global.defaultError({ msg: res.data.mensagem || 'Falha ao gravar o lote' });
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          const msg = err.response && err.response.data;
          this.$toasted.global.defaultError({ msg: typeof msg === 'string' ? msg : 'Não foi possível importar o PDF' });
        });
    },
    getValidation(unConv = false) {
      unConv = (this.consignatario.unConv && Number(this.consignatario.unConv) === 1) ? true : false;
      const url = `${baseApiUrl}/con-validacoes${unConv ? '-un-conv' : ''}/f-a/gcp`;
      const obj = { ...this.contrato };
      axios.post(url, obj).then((res) => {
        this.exibirValidacao(res.data.inconsistencias);
      });
    },
    exibirValidacao(lista) {
      this.validationResult = [];
      (lista || []).forEach((validation) => {
        this.validationResult.push(this.formatarDadosParaHTML(validation));
      });
    },
    formatarDadosParaHTML(dados) {
      let htmlString = '<p style="border: groove; border-radius: 5px; padding: 5px 0px 5px 5px;">';

      for (const key in dados) {
        if (Object.prototype.hasOwnProperty.call(dados, key)) {
          const value = dados[key];

          // Verifica se o valor é um objeto
          if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
            htmlString += `<strong>${capitalizeFirst(key.replaceAll('_', ' '))}:</strong><br />`;

            // Adiciona indentação para os detalhes
            for (const subKey in value) {
              if (Object.prototype.hasOwnProperty.call(value, subKey)) {
                const subValue = value[subKey];
                htmlString += `<span style="margin-left: 20px;"><strong>${capitalizeFirst(subKey.replaceAll('_', ' '))}:</strong> ${subValue}</span><br />`;
              }
            }
          } else if (Array.isArray(value)) {
            htmlString += `<strong>${capitalizeFirst(key.replaceAll('_', ' '))}:</strong>`;
            htmlString += '<ul>';
            value.forEach((item) => {
              htmlString += `<li>${item.text}</li>`;
            });
            htmlString += '</ul>';
          } else {
            htmlString += `<strong>${capitalizeFirst(key.replaceAll('_', ' '))}:</strong> ${value}<br />`;
          }
        }
      }

      htmlString += '</p>';
      return htmlString;
    },
    save(unConv = false) {      
      unConv = (this.consignatario.unConv && Number(this.consignatario.unConv) === 1) ? true : false;
      const url = `${baseApiUrl}/con-validacoes${unConv ? '-un-conv' : ''}`
      this.isValid = false;
      this.loading = !this.loading;
      const obj = { ...this.contrato };
      axios.post(url, obj)
        .then((res) => {
          this.$toasted.global.defaultSuccess({ msg: res.data.data });
          this.isValid = res.data.isValid || false;
          this.loading = !this.loading;
          this.exibirValidacao(res.data.inconsistencias);
        })
        .catch((err) => {
          console.log(err);
          this.loading = !this.loading;
          showError(err);
        });
    },
    downloadFiles(unConv = false) {      
      unConv = (this.consignatario.unConv && Number(this.consignatario.unConv) === 1) ? true : false;
      const url = `${baseApiUrl}/con-validacoes${unConv ? '-un-conv' : ''}/f/gimf`
      axios.get(url).then((res) => {
        const data = JSON.stringify(res.data);
        const element = document.createElement("a");
        element.setAttribute(
          "href",
          "data:text/plain;charset=utf-8," +
          encodeURIComponent(
            data
              .replaceAll('","', "\n")
              .replaceAll('","', "\n")
              .replaceAll('"', "")
              .replaceAll("},", "}" + "\n")
              .replaceAll(",{", "\n" + "{")
              .replaceAll("[", "")
              .replaceAll("]", "")
          )
        );
        element.setAttribute("download", "filename.txt");
        element.style.display = "none";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      });
    },
    onShown() {
      if (this.$refs.cancel) this.$refs.cancel.focus();
    },
    onHidden() { },
    async loadUserParams() {
      const url = `${baseApiUrl}/users/${this.user.id}`;
      await axios.get(url).then((res) => {
        this.userParams = res.data;
        this.userParams.domainCli = `${this.userParams.cliente}_${this.userParams.dominio}`;

        this.contrato.exercicio = `${this.userParams.f_ano}${String(this.userParams.f_mes).padStart(2, "0")}`;
        this.contrato.id_consignatario = 1;
      });
    },
  },
  async mounted() {
    this.setExercicios();
    await this.loadUserParams();
    await this.getConsignees();
  },
  computed: {
    ...mapState(["user"]),
    camposOperacao() {
      return !!(this.contrato.exercicio && this.contrato.versao);
    },
    podeImportarPdf() {
      return !!(this.pdfFile && !this.loading && this.camposOperacao);
    },
  },
};
</script>

<style scoped>
.bb-note {
  color: #6c757d;
  font-size: 0.85rem;
  margin: 0;
}

.validacao-barra {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem;
}

.validacao-botoes {
  display: flex;
  gap: 0.5rem;
}

.campo-exercicio {
  width: 8.5rem;
}

.campo-versao {
  width: 4.5rem;
}

.pdf-drop {
  border: 2px dashed #6c757d;
  border-radius: 6px;
  padding: 1.25rem;
  text-align: center;
  cursor: pointer;
  background: #f8f9fa;
}

.pdf-drop-active {
  border-color: #007bff;
  background: #e7f1ff;
}

.pdf-drop-off {
  cursor: not-allowed;
  opacity: 0.75;
}
</style>